import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  convertToCurrencyFormat,
  getSerialFromBarcode,
  stockUnitOfMeasureOptions,
  isReadOnlyUser,
} from "../../shared/utility";

export default function CreditReturnCartonsTable(props) {
  const { askDeleteCarton, closed, values } = props;
  const isReadOnly = isReadOnlyUser();

  function bodyActions(rowData) {
    return (
      <div className="flex">
        {rowData.deleted_at ? (
          <p className="text-black font-bold text-lg">DELETED</p>
        ) : (
          !isReadOnly && !closed && (
            <button
              onClick={() => {
                askDeleteCarton(rowData.id);
              }}
              className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
            >
              Delete
            </button>
          )
        )}
      </div>
    );
  }

  const productDetailsBody = (rowData) => {
    return (
      <p>
        <span className="text-gray-900 font-semibold">
          {rowData.product_name}
        </span>
        <br />
        <span className="text-gray-700">PLU:{rowData.plu}</span>
      </p>
    );
  };

  const unitCostBody = (rowData) => {
    const stockUofM = stockUnitOfMeasureOptions.find(
      (opt) => opt.value === rowData.selling_unit_of_measure
    )?.label;
    return (
      <p>
        {convertToCurrencyFormat(rowData.unit_cost)}/{stockUofM}
      </p>
    );
  };

  const totalCostBody = (rowData) => {
    var totalCost = 4;

    if (rowData.selling_unit_of_measure === 1) {
      totalCost =
        parseFloat(rowData.weight_in_kg) * parseFloat(rowData.unit_cost);
    } else if (rowData.selling_unit_of_measure === 2) {
      totalCost =
        parseFloat(rowData.weight_in_lbs) * parseFloat(rowData.unit_cost);
    } else {
      totalCost =
        parseFloat(rowData.piece_count) * parseFloat(rowData.unit_cost);
    }

    return <p>{convertToCurrencyFormat(totalCost)}</p>;
  };

  const totalShippedWeightParent = (rowData) => {
    return (
      <div>
        <p>{rowData.weight_in_kg}kg</p>
        <p>{rowData.weight_in_lbs}lbs</p>
        <p>{rowData.piece_count} pieces</p>
      </div>
    );
  };

  const unitTypeBody = (value) => {
    switch (value.selling_unit_of_measure) {
      case 1:
        return "kg";

      case 2:
        return "lbs";

      case 3:
        return "pieces";

      default:
        return "N/A";
    }
  };

  const barcodeBody = (rowData) => {
    return <p>{getSerialFromBarcode(rowData.barcode)}</p>;
  };

  return (
    <div className="">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden">
            <DataTable
              value={values.items}
              dataKey="id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 cr-items-table-parent"
              cellClassName="p-2 bg-white border-1-bottom-gray text-sm"
            >
              <Column header="Product" body={productDetailsBody} />
              <Column header="Barcode" body={barcodeBody} />
              <Column header="Lot Number" field="lot_number" />

              <Column
                header="Amount"
                body={totalShippedWeightParent}
                style={{ textAlign: "right" }}
              />

              <Column
                header="Unit Cost"
                field="unit_cost"
                style={{ textAlign: "right" }}
                body={unitCostBody}
              />

              <Column
                header="Total Cost"
                field="total_cost"
                style={{ textAlign: "right" }}
                body={totalCostBody}
              />

              <Column header="" body={bodyActions} />
            </DataTable>
          </div>

          {/* <div className="w-full text-right mt-4">
            <p className="font-bold">
              Subtotal: {convertToCurrencyFormat (values.subtotal_dollar_amount)}
            </p>
            <p className="font-bold">
              Taxes: {convertToCurrencyFormat(values.tax_amount)}
            </p>
            <p className="font-bold">
              Total: {convertToCurrencyFormat(values.total_dollar_amount)}
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
}
